import React from 'react';
import './RankingListItem.css';

const RankingListItem = ({ item }) => {
  return (
    <div className="bts-rank-item">
      <div className="bts-rank-item__number">{item.rank}</div>

      <div className="bts-rank-item__mid">
        <div className="bts-rank-item__avatar">
          {item.pictureUrl ? (
            <img src={item.pictureUrl} alt={item.name} className="bts-rank-item__avatar-img" />
          ) : (
            <span>{item.avatar || '👥'}</span>
          )}
        </div>
        <div className="bts-rank-item__info">
          <p className="bts-rank-item__team">{item.team}</p>
          <p className="bts-rank-item__name">{item.name}</p>
        </div>
      </div>

      <div className="bts-rank-item__points">
        {item.points.toLocaleString()}
        <span className="bts-rank-item__pts-unit">คะแนน</span>
      </div>
    </div>
  );
};

export default RankingListItem;
